import React, { useState, useEffect } from "react";
import { getFilteredDocuments } from "../data/common";
import InnerCompnents from "../components/innercomponents/innercomponents";

function EarthingComponents() {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      getFilteredDocuments("products", "category", "==", "Earthing Products")
        .then((res) => { 
          setData(res);
         })
        .catch((err) => { console.log(err); });
    };

    fetchData();
  }, []);
  return (
    <>
      <div className="container-fluid">
        
        <InnerCompnents
          componentsData={data}
        ></InnerCompnents>
      </div>
    </>
  );
}

export default EarthingComponents;
